import React from 'react';
import styles from './AdminDrawer.module.css';
import { AdminDrawerData } from '../../../Data/AdminDrawerData';
import Tooltip from '../../../Components/Utils/Tooltip/Tooltip';

type AdminDrawerProps = {
  selectedItem: string;
  onItemSelect: (item: string) => void;
  canMandateToSubsets?: boolean;
  onMoreAdminControlsClick?: () => void;
};

const AdminDrawer = ({ selectedItem, onItemSelect, canMandateToSubsets, onMoreAdminControlsClick }: AdminDrawerProps) => {
  return (
    <div className={styles.drawer}>
      <nav className={styles.drawerNav}>
        {AdminDrawerData.map((item) => {
          const isMandateTemplates = item.id === 'mandate-templates';
          const isDisabled = isMandateTemplates && !canMandateToSubsets;
          
          const button = (
            <button
              key={item.id}
              className={`${styles.drawerItem} ${
                selectedItem === item.id ? styles.drawerItemActive : ''
              } ${isDisabled ? styles.drawerItemDisabled : ''}`}
              onClick={() => !isDisabled && onItemSelect(item.id)}
              disabled={isDisabled}
            >
              {item.label}
            </button>
          );

          if (isDisabled) {
            return (
              <Tooltip 
                key={item.id}
                text="This feature requires partners or departments to be configured for your organisation."
                align="top"
                sideAlign="right"
              >
                {button}
              </Tooltip>
            );
          }

          return button;
        })}
      </nav>
      <div className={styles.drawerFooter}>
        <button
          type="button"
          className={styles.moreAdminControlsButton}
          onClick={onMoreAdminControlsClick}
        >
          <img src="/img/gear.svg" alt="" aria-hidden className={styles.moreAdminControlsIcon} />
          More Admin Controls
        </button>
      </div>
    </div>
  );
};

export default AdminDrawer;
